import { render, staticRenderFns } from "./LabellingGuideDialog.vue?vue&type=template&id=2b579ef9&scoped=true&"
import script from "./LabellingGuideDialog.vue?vue&type=script&lang=js&"
export * from "./LabellingGuideDialog.vue?vue&type=script&lang=js&"
import style0 from "./LabellingGuideDialog.vue?vue&type=style&index=0&id=2b579ef9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b579ef9",
  null
  
)

export default component.exports